import { AtlassianProductHostingTypeValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
export var PromotionStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  ENDED_EARLY: 'ENDED_EARLY'
});
export var PromotionType = Object.freeze({
  SINGLE_USE_PROMOTION: 'SINGLE_USE_PROMOTION',
  SHARED_PROMOTION: 'SHARED_PROMOTION'
});
export var DiscountType = Object.freeze({
  FLAT_DISCOUNT: 'FLAT_DISCOUNT',
  TIERED_DISCOUNT: 'TIERED_DISCOUNT'
});
export var SubscriptionType = Object.freeze({
  MONTHLY: 'MONTHLY',
  ANNUAL: 'ANNUAL'
});
export var PromotionOrderBy = Object.freeze({
  CREATION_DATE: 'creationDate',
  START_DATE: 'startDate',
  EXPIRATION_DATE: 'endDate'
});